// export default async function buildTransactionRequest({
//   to,
//   data,
//   value,
//   txOptions,
// }) {
//   const tx = {
//     to,
//     data,
//     value,
//     ...(txOptions?.gasLimit && { gasLimit: txOptions.gasLimit })
//   };


//   return tx;
// }





// export default async function buildTransactionRequest({ to, data, value, txOptions, signer }) {
//   const tx = {
//     to,
//     data,
//     value,
//   }

//   // If gasLimit is explicitly provided, use it
//   if (txOptions?.gasLimit) {
//     tx.gasLimit = txOptions.gasLimit
//     return tx
//   }

//   // Otherwise, estimate gas with a 20% buffer for safety
//   if (signer) {
//     try {
//       const estimatedGas = await signer.estimateGas(tx)
//       // Add 20% buffer to estimated gas
//       const gasWithBuffer = estimatedGas.mul(120).div(100)
//       tx.gasLimit = gasWithBuffer

//       console.log("[v0] Gas estimation:", {
//         estimated: estimatedGas.toString(),
//         withBuffer: gasWithBuffer.toString(),
//       })
//     } catch (error) {
//       console.warn("[v0] Gas estimation failed, using default limits:", error.message)
//       // Fallback to reasonable defaults if estimation fails
//       // These are much lower than the previous hardcoded values
//       tx.gasLimit = 15000
//     }
//   }

//   return tx
// }




// export default async function buildTransactionRequest({ to, data, value, txOptions, signer }) {
//   const tx = {
//     to,
//     data,
//     value,
//   }

//   // If gasLimit is explicitly provided, use it
//   if (txOptions?.gasLimit) {
//     tx.gasLimit = txOptions.gasLimit
//     return tx
//   }

//   // Otherwise, estimate gas with a 20% buffer for safety
//   if (signer) {
//     try {
//       const estimatedGas = await signer.estimateGas(tx)
//       // Add 20% buffer to estimated gas
//       const gasWithBuffer = estimatedGas.mul(120).div(100)
//       tx.gasLimit = gasWithBuffer

//       console.log("[v0] Gas estimation:", {
//         estimated: estimatedGas.toString(),
//         withBuffer: gasWithBuffer.toString(),
//       })
//     } catch (error) {
//       console.warn("[v0] Gas estimation failed, using default limits:", error.message)
//       tx.gasLimit = 400000
//     }
//   }

//   console.log("[v0] Final transaction object:", tx)

//   return tx
// }







export default async function buildTransactionRequest({ to, data, value, txOptions, signer }) {
  const tx = {
    to,
    data,
    value,
  }

  // If gasLimit is explicitly provided, use it
  if (txOptions?.gasLimit) {
    tx.gasLimit = txOptions.gasLimit
    return tx
  }

  // Otherwise, estimate gas with a 20% buffer for safety
  if (signer) {
    try {
      const estimatedGas = await signer.estimateGas(tx)
      // Add 20% buffer to estimated gas
      const gasWithBuffer = estimatedGas.mul(120).div(100)
      tx.gasLimit = gasWithBuffer

      console.log("[v0] Gas estimation:", {
        estimated: estimatedGas.toString(),
        withBuffer: gasWithBuffer.toString(),
      })
    } catch (error) {
      console.warn("[v0] Gas estimation failed, using fallback:", error.message)
      tx.gasLimit = 250000
    }
  }

  console.log("[v0] Final transaction object:", tx)

  return tx
}
